import { isPortfolioPublicUrl } from '@/features/portfolio/_utils/resolve-portfolio-attribution';

export function resolveUtmReferrerValues(input: {
  storedPortfolioUrl: string;
  storedReferrer: string;
  urlPortfolioUrl: string;
  urlReferrer: string;
  urlUtmReferrer: string;
}): { portfolioUrl: string | null; referrer: string } {
  const portfolioUrl =
    input.urlPortfolioUrl ||
    (input.urlReferrer && isPortfolioPublicUrl(input.urlReferrer) ? input.urlReferrer : '') ||
    input.storedPortfolioUrl ||
    (input.storedReferrer && isPortfolioPublicUrl(input.storedReferrer) ? input.storedReferrer : '') ||
    null;

  const referrer =
    [input.urlReferrer, input.urlUtmReferrer, input.storedReferrer].find(
      (value) => value && !isPortfolioPublicUrl(value),
    ) ?? '';

  return { referrer, portfolioUrl };
}

export function resolvePortfolioUrlToPersist(input: { urlPortfolioUrl: string; urlReferrer: string }): string {
  return (
    input.urlPortfolioUrl || (input.urlReferrer && isPortfolioPublicUrl(input.urlReferrer) ? input.urlReferrer : '')
  );
}

export function resolveReferrerToPersist(input: { urlReferrer: string; urlUtmReferrer: string }): string {
  return [input.urlReferrer, input.urlUtmReferrer].find((value) => value && !isPortfolioPublicUrl(value)) ?? '';
}
